import Vue from "vue";
import Vuex from "vuex";
import { db } from "@/main";
import firebase from "firebase";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    items: null,
    user: null
  },
  getters: {
    getItems: state => {
      return state.items;
    },
    getUser: state => {
      return state.user;
    }
  },
  mutations: {
    setItems: state => {
      let items = [];
      db.collection("items")
        .orderBy("created_at")
        .onSnapshot(snapshot => {
          items = [];
          snapshot.forEach(doc => {
            items.push({
              id: doc.id,
              title: doc.data().title,
              feeling: doc.data().feeling,
              author: doc.data().author,
              createdby: doc.data().created_by_name,
              createdbyid: doc.data().created_by,
              link: doc.data().link,
              category: doc.data().category,
              when: doc.data().created_at
            });
          });
          state.items = items;
        });
    },

    setUser: state => {
      let ref = db.collection("users").doc(firebase.auth().currentUser.uid);
      ref.get().then(user => {
        //DocSnapshot
        if (user.exists) {
          state.user = {
            created: user.data().created,
            email: user.data().emal,
            name: user.data().name,
            username: user.data().username,
            uuid: user.data().uuid
          };
          // let post = snapshot.data()
        } else {
          // snapshot.data() will be undefined in this case
          console.log("No such user!");
        }
      });
    }
  },
  actions: {
    setItems: context => {
      context.commit("setItems");
    },
    setUser: context => {
      context.commit("setUser");
    }
  }
});
